import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { trackAddNewPlanningVersionStart } from 'modules/time_planning/lib/trackEvents'

export interface Props {
  onClose: () => void
  onSubmit: () => void
  setCreateModalOpen: (value: boolean) => void
  changingNumberOfRestDays: boolean
}

const ConfirmModal = ({
  onClose,
  onSubmit,
  setCreateModalOpen,
  changingNumberOfRestDays,
}: Props) => {
  const onCreateNewPlanningVersion = () => {
    setCreateModalOpen(true)
    trackAddNewPlanningVersionStart('edit_modal')
  }

  const descriptionMessage = changingNumberOfRestDays
    ? i18n.t(
        'time_planning.planning_versions.modal.update_planning_tool.description_number_of_rest_days'
      )
    : i18n.t('time_planning.planning_versions.modal.update_planning_tool.description')

  const warningMessage = changingNumberOfRestDays
    ? i18n.t(
        'time_planning.planning_versions.modal.update_planning_tool.warning_number_of_rest_days'
      )
    : i18n.t('time_planning.planning_versions.modal.update_planning_tool.warning')

  return (
    <Modal
      onClose={onClose}
      onSubmit={onSubmit}
      illustration="document-edit"
      title={i18n.t('time_planning.planning_versions.modal.update_planning_tool.title')}
      description={descriptionMessage}
      footer={
        <Box flexDirection="row" gap="s8">
          <Button submit type="secondary">
            {i18n.t(
              'time_planning.planning_versions.modal.update_planning_tool.change_version_button'
            )}
          </Button>
          <Button onClick={onCreateNewPlanningVersion}>
            {i18n.t(
              'time_planning.planning_versions.modal.update_planning_tool.create_version_button'
            )}
          </Button>
        </Box>
      }
    >
      <Box
        paddingX="s24"
        paddingY="s16"
        background="champagne400"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Text.Normal>{warningMessage}</Text.Normal>
      </Box>
    </Modal>
  )
}

export default observer(ConfirmModal)
